import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../../../Globals/constants';
import { DropTarget } from 'react-dnd';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';

class EmployeeDropableSorter extends Component {
  render() {
    const { connectDropTarget, isOver, index, isLast, canDrop } = this.props;

    let isOverAndCanDrop = canDrop && isOver;

    return(
      <div style={[isLast && styles.isLastContainer]}>
        {connectDropTarget(
          <div style={[styles.dropTarget, index === 0 && styles.firstSorter, isOverAndCanDrop && styles.isOverDropTarget, isLast && styles.lastSorter]}></div>
        )}
        <div style={[styles.dropContainer, isOverAndCanDrop && styles.isOverDropContainer]}></div>
      </div>
    )
  }
}


var styles = {
  dropTarget: {
    top: '-20px',
    height: '52px',
    position: 'absolute',
    width: '100%'
  },
  firstSorter: {
    top: '0',
    left: '0',
    height: '32px'
  },
  lastSorter:{
    top: '32px'
  },
  isOverDropTarget: {
    height: '64px'
  },
  dropContainer: {
    height: '0px',
    marginTop: '0px',
    position: 'static',
    transition: 'height 0.2s'
  },
  isOverDropContainer: {
    height: '40px',
    marginTop: '12px',
    backgroundColor: greyScaleColors.greyLighter,
    border: '1px dashed ' + semanticColors.info,
    clear: 'both'
  },
  isLastContainer:{
    paddingTop: '52px'
  }
}

const SorterEmployeeTarget = {

  drop(props, monitor) {
    if(monitor.didDrop()) return;

    props.moveEmployee(monitor.getItem().employeeIndex, props.isLast ? props.index+1 : props.index)
  },
  canDrop(props, monitor) {
    return (props.index!==monitor.getItem().employeeIndex && props.index-1!==monitor.getItem().employeeIndex)
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop()
  };
}
  EmployeeDropableSorter.propTypes = {
    isOver: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    isLast: PropTypes.bool.isRequired,
    moveEmployee: PropTypes.func.isRequired
  };
export default DropTarget(dragNDropConstants.EMPLOYEE, SorterEmployeeTarget, collect)(Radium(EmployeeDropableSorter));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/EmployeeListView/employeeDropableSorter.jsx